import axios from "axios"

const client = axios.create({ baseURL: "/api", headers: { Accept: "application/json" } })

client.interceptors.request.use((config) => {
  config.headers["X-CSRF-Token"] = document.querySelector('meta[name="csrf-token"]')?.content
  if (!(config.data instanceof FormData)) config.headers["Content-Type"] = "application/json"
  return config
})

client.interceptors.response.use(
  (response) => (response.status === 204 ? null : response.data),
  (error) => {
    // An expired admin session answers 401 on every API call; send the person
    // back to sign in instead of leaving pages spinning. The session endpoint
    // itself and the cleaner portal are exempt.
    const url = error.config?.url || ""
    const onSignIn = window.location.pathname.startsWith("/session") || window.location.pathname.startsWith("/c/")
    if (error.response?.status === 401 && !url.startsWith("/session") && !url.startsWith("/cleaner_portal") && !onSignIn) {
      window.location.assign("/session/new")
    }
    return Promise.reject(new Error(error.response?.data?.error || error.message))
  },
)

export default client
